module.exports = __webpack_public_path__ + "static/media/cq_alert.a572f65e.svg";